import { blocks, view } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';
import getClosestBlockElement from 'src/js/modules/common/helpers/get-closest-block-element';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackSelectLayerElement = ({ elementId, layerElementType }) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const block = getClosestBlockElement(liveElement);
  const blockId = blocks.accessors.getBlockIdByElement(block);
  const blockVariationId = blocks.accessors.getVariationIdByElement(block);

  trackEvent(constants.events.LAYER_ELEMENT_SELECTED, {
    blockId,
    blockVariationId,
    layerElementType,
  });
};

export default trackSelectLayerElement;
